<script>
import axios from 'axios'
import { EyeIcon, MapIcon } from 'vue-feather-icons'
import toastStore from '@/stores/toast-store.js'

import ConfirmationModal from '@/vcs/_shared/modals/confirmation-modal/cmp.vue'
import ShowCpModal from '@/vcs/_shared/modals/show-cp-modal/cmp.vue'
import ShowCpMapModal from '@/vcs/_shared/modals/show-cp-map-modal/cmp.vue'
import BookSelectedLockerModal from '@/vcs/_shared/modals/book-selected-locker-modal/cmp.vue'

export default {
  name: 'CpCard',
  props: { cp: Object, closeFn: Function },
  data: function () {
    return {
      blocker: false,
    }
  },

  methods: {
    assignLockerOnDemand(boxId = false) {
      this.blocker = true
      const params = {}
      if (boxId) {
        params.box_id = boxId
      }
      axios({
        method: 'put',
        url: `collection_points/${this.cp.id}/assign_on_demand_by_user`,
        params: params,
      })
        .then(response => {
          mainApp.$emit(`updateLockers`)
          toastStore.commit('success', {
            message: 'Assigned successfully',
          })
          response.status == 200 ? this.$store.commit('modal/closeAllModals') : null
        })
        .catch(error => {
          this.$errorHumanized({ error })
        })
        .finally(() => {
          this.blocker = false
        })
    },
    confirmAndAssignLockerOnDemand() {
      this.$store.commit('modal/open', {
        cmp: ConfirmationModal,
        animation: 'slide-down-menu',
        callback: () => {
          this.assignLockerOnDemand()
        },
      })
    },
    openShowCpModal(cp) {
      this.$store.commit('modal/open', {
        cmp: ShowCpModal,
        animation: 'slide-down-menu',
        data: {
          cpId: cp.id,
          type: 'locker',
        },
      })
    },
    openShowCpMapModal(id) {
      this.$store.commit('modal/open', {
        cmp: ShowCpMapModal,
        animation: 'slide-down-menu',
        data: {
          cpId: id,
          type: 'locker',
        },
      })
    },
    openBookSelectedLockerModal(cp) {
      this.$store.commit('modal/open', {
        cmp: BookSelectedLockerModal,
        animation: 'slide-down-menu',
        data: {
          cpId: cp.id,
          type: 'locker',
        },
        callback: event => {
          this.assignLockerOnDemand(event)
        },
      })
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
    ConfirmationModal,
    EyeIcon,
    MapIcon,
  },
}
</script>

<template lang="pug">
.collectomate
  .row.collectomate-header
    .col-8
      span {{ cp.name }}
    .col-4
      .d-flex.align-items-center.justify-content-end
        button.btn.btn-round-small.btn-secondary.d-flex.align-items-center.justify-content-center.mr-2(
          v-if="cp.mapImage.url"
          @click="openShowCpMapModal(cp.id)"
          type="button"
        )
          map-icon.text-white(size="1.5x")
        button.btn.btn-round-small.btn-secondary.d-flex.align-items-center.justify-content-center(
          @click="openShowCpModal(cp)"
          type="button"
        )
          eye-icon.text-white(size="1.5x")

  .collectomate-address {{ cp.address }}
  template(v-if="cp.freeBoxesCount > 0")
    .collectomate-address {{ $t('lockerOnDemand.currentlyAvailableLockers') }}: {{ cp.freeBoxesCount }}
  template(v-else)
    .collectomate-address {{ $t('lockerOnDemand.noAvailableLockers') }}

  button.btn.btn.btn-primary.btn-block.d-flex.align-items-center.justify-content-between(
    :class="{ 'btn-light': !cp.freeBoxesCount, 'text-white': cp.freeBoxesCount }"
    :disabled="!cp.freeBoxesCount"
    @click="openBookSelectedLockerModal(cp)"
    type="button"
  )
    span {{ $t('lockerOnDemand.bookSelectedLocker') }}
    i.cl.cl-close

  button.btn.btn.btn-secondary.btn-block.d-flex.align-items-center.justify-content-between(
    :class="{ 'btn-light': !cp.freeBoxesCount, 'text-white': cp.freeBoxesCount }"
    :disabled="!cp.freeBoxesCount"
    @click="confirmAndAssignLockerOnDemand()"
    type="button"
  )
    span {{ $t('lockerOnDemand.bookLocker') }}
    i.cl.cl-close
  blocker(v-if="blocker")
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.collectomate {
  padding: 20px;
  border: solid $gray-lighter 1px;
  border-radius: 18px;
  margin-bottom: 1rem;
  position: relative;

  .collectomate-header {
    margin-bottom: 0.5rem;
  }

  .collectomate-address {
    font-size: 14px;
    margin-bottom: 0.5rem;
    color: $gray;
  }

  .btn-round-smaller {
    .cl-close {
      display: block;
      transform: rotate(45deg);
      font-size: 12px;
    }
  }

  .cl-close {
    display: block;
    transform: rotate(45deg);
    font-size: 12px;
  }
}
</style>
